function Confirmation(email, phoneNumber, date, evaluation) {
    $("#reminder-email").text(email);
    $("#reminder-phone-number").text(phoneNumber);
    $("#reminder-date").text(date.replace('&#xFB;', 'û').replace('&#xE9;', 'é'));
    $("#reminder-evaluation").text(evaluation);
};
